import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "heading d-flex" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["innerHTML"]


export default /*@__PURE__*/_defineComponent({
  __name: 'Dialog',
  props: {
  modelValue: {
    type: Object,
    required: true
  },
  title: {
    type: String,
    default: null
  },
  subtitle: {
    type: String,
    default: null
  },
  width: {
    type: [String, Number],
    default: "50%"
  },
  height: {
    type: [String, Number],
    default: null
  },
  persistent: {
    type: Boolean,
    default: false
  },
  hideCloseButton: {
    type: Boolean,
    default: false
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_hy_button = _resolveComponent("hy-button")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: __props.modelValue.status,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.modelValue.status) = $event)),
    width: __props.width,
    height: __props.height,
    persistent: __props.persistent,
    fullscreen: _ctx.$ui.mobile,
    class: "hy-dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          (__props.title)
            ? (_openBlock(), _createBlock(_component_v_card_title, {
                key: 0,
                class: "header d-flex ga-2 align-center justify-space-between"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
                    (__props.subtitle)
                      ? (_openBlock(), _createBlock(_component_v_divider, {
                          key: 0,
                          class: "mx-2",
                          vertical: ""
                        }))
                      : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "subtitle", {}, () => [
                      _createElementVNode("div", {
                        class: "subtitle",
                        innerHTML: __props.subtitle
                      }, null, 8, _hoisted_3)
                    ])
                  ]),
                  _renderSlot(_ctx.$slots, "close", {}, () => [
                    (!__props.hideCloseButton)
                      ? (_openBlock(), _createBlock(_component_hy_button, {
                          key: 0,
                          type: "Close",
                          icon: "",
                          onAction: __props.modelValue.close
                        }, null, 8, ["onAction"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 3
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card_text, {
            class: _normalizeClass(["body", { 'pa-2': _ctx.$ui.mobile }])
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["class"]),
          (_ctx.$slots.options || _ctx.$slots.actions)
            ? (_openBlock(), _createBlock(_component_v_card_actions, {
                key: 1,
                class: "footer pr-4"
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "options"),
                  _createVNode(_component_v_spacer),
                  _renderSlot(_ctx.$slots, "actions")
                ]),
                _: 3
              }))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue", "width", "height", "persistent", "fullscreen"]))
}
}

})